<template>
    <div class="iso-widget-with-text__widget">
        <div class="iso-widget-with-text__widget__tabs" role="tablist" aria-label="Booking options">
            <button
                v-if="!tabs.tab01Toggle"
                class="iso-widget-with-text__widget__tab iso-widget-with-text__widget--tab01"
                role="tab"
                :aria-label="tabs.tab01Tab"
                :aria-selected="activeTab === 'tab01'"
                aria-controls="panel-tab01"
                id="tab-tab01"
                @click="setActiveTab('tab01')"
                :tabindex="getTabIndex('tab01')">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <rect x="4.5" y="9.5" width="23" height="16" rx="1.5" stroke="black" stroke-width="3" fill="none"/>
                        <path d="M10 11V24" stroke="black" stroke-width="2"/>
                        <path d="M22 11V24" stroke="black" stroke-width="2"/>
                        <rect x="13" y="4" width="6" height="6" rx="2" stroke="black" stroke-width="2"/>
                    </svg>
                    {{ tabs.tab01Tab }}
            </button>
            <button
                v-if="!tabs.tab02Toggle"
                class="iso-widget-with-text__widget__tab iso-widget-with-text__widget--tab02"
                role="tab"
                :aria-label="tabs.tab02Tab"
                :aria-selected="activeTab === 'tab02'"
                aria-controls="panel-tab02"
                id="tab-tab02"
                @click="setActiveTab('tab02')"
                :tabindex="getTabIndex('tab02')">
                    <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <path d="M19.9844 16.5117C21.0868 16.5117 21.9805 17.4054 21.9805 18.5078V21.4961C21.9805 22.0484 21.5328 22.4961 20.9805 22.4961C20.4325 22.4961 19.9883 22.9403 19.9883 23.4883C19.9883 24.0363 20.4325 24.4805 20.9805 24.4805C21.5328 24.4805 21.9805 24.9282 21.9805 25.4805V28.4688C21.9805 29.5712 21.0868 30.4648 19.9844 30.4648H2.05469C0.952275 30.4648 0.0585938 29.5712 0.0585938 28.4688V25.4805C0.0585938 24.9282 0.506309 24.4805 1.05859 24.4805C1.60656 24.4805 2.05078 24.0363 2.05078 23.4883C2.05078 22.9403 1.60656 22.4961 1.05859 22.4961C0.506309 22.4961 0.0585938 22.0484 0.0585938 21.4961V18.5078C0.0585938 17.4054 0.952275 16.5117 2.05469 16.5117H19.9844ZM2.05859 20.667C3.21939 21.0785 4.05078 22.1864 4.05078 23.4883C4.05078 24.7901 3.21939 25.8981 2.05859 26.3096V28.4648H19.9805V26.3096C18.8197 25.8981 17.9883 24.7901 17.9883 23.4883C17.9883 22.1864 18.8197 21.0785 19.9805 20.667V18.5117H2.05859V20.667ZM7.03516 20.4961C7.58744 20.4961 8.03516 20.9438 8.03516 21.4961V25.4805C8.03516 26.0328 7.58744 26.4805 7.03516 26.4805C6.48287 26.4805 6.03516 26.0328 6.03516 25.4805V21.4961C6.03516 20.9438 6.48287 20.4961 7.03516 20.4961ZM29.9453 2.56641C31.0477 2.56641 31.9414 3.46009 31.9414 4.5625V7.55078C31.9414 8.10307 31.4937 8.55078 30.9414 8.55078C30.3934 8.55078 29.9492 8.995 29.9492 9.54297C29.9492 10.0909 30.3934 10.5352 30.9414 10.5352C31.4937 10.5352 31.9414 10.9829 31.9414 11.5352V14.5234C31.9414 15.6258 31.0477 16.5195 29.9453 16.5195H24.9648C24.4126 16.5195 23.9648 16.0718 23.9648 15.5195C23.9648 14.9672 24.4126 14.5195 24.9648 14.5195H29.9414V12.3643C28.7806 11.9528 27.9492 10.8448 27.9492 9.54297C27.9492 8.24113 28.7806 7.13318 29.9414 6.72168V4.56641H12.0195V6.72168C13.1803 7.13318 14.0117 8.24113 14.0117 9.54297C14.0117 10.8448 13.1803 11.9528 12.0195 12.3643V13.5273C12.0195 14.0796 11.5718 14.5273 11.0195 14.5273C10.4672 14.5273 10.0195 14.0796 10.0195 13.5273V11.5352C10.0195 10.9829 10.4672 10.5352 11.0195 10.5352C11.5675 10.5352 12.0117 10.0909 12.0117 9.54297C12.0117 8.995 11.5675 8.55078 11.0195 8.55078C10.4672 8.55078 10.0195 8.10307 10.0195 7.55078V4.5625C10.0195 3.46009 10.9132 2.56641 12.0156 2.56641H29.9453ZM16.9961 6.55078C17.5484 6.55078 17.9961 6.9985 17.9961 7.55078V11.5352C17.9961 12.0874 17.5484 12.5352 16.9961 12.5352C16.4438 12.5352 15.9961 12.0874 15.9961 11.5352V7.55078C15.9961 6.9985 16.4438 6.55078 16.9961 6.55078Z" fill="black"/>
                    </svg>                
                    {{ tabs.tab02Tab }}
            </button>
            <button
                v-if="!tabs.tab03Toggle"
                class="iso-widget-with-text__widget__tab iso-widget-with-text__widget--tab03"
                role="tab"
                :aria-label="tabs.tab03Tab"
                :aria-selected="activeTab === 'tab03'"
                aria-controls="panel-tab03"
                id="tab-tab03"
                @click="setActiveTab('tab03')"
                :tabindex="getTabIndex('tab03')">
                    <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                    <path d="M24.4209 11C25.845 11 26.9998 12.1708 27 13.6152V27.3848C26.9998 28.8292 25.845 30 24.4209 30H4.5791C3.15502 30 2.00024 28.8292 2 27.3848V13.6152C2.00024 12.1708 3.15502 11 4.5791 11H24.4209ZM3.71875 27.3848C3.71899 27.8661 4.1045 28.2559 4.5791 28.2559H24.4209C24.8955 28.2559 25.281 27.8661 25.2812 27.3848V19H3.71875V27.3848ZM8.21973 22C8.65068 22.0001 9 22.4478 9 23C9 23.5522 8.65068 23.9999 8.21973 24H5.78027C5.34932 23.9999 5 23.5522 5 23C5 22.4478 5.34932 22.0001 5.78027 22H8.21973ZM27.3496 2C28.8132 2.00002 29.9998 3.19053 30 4.65918V18.1377C29.9999 18.6139 29.6152 18.9999 29.1406 19C28.666 19 28.2814 18.614 28.2812 18.1377V9H6.71875V9.15234C6.71868 9.62868 6.33408 10.0146 5.85938 10.0146C5.38478 10.0145 5.00007 9.6286 5 9.15234V4.65918C5.00024 3.19053 6.18676 2.00002 7.65039 2H27.3496ZM4.5791 12.7441C4.1045 12.7441 3.71899 13.1339 3.71875 13.6152V17H25.2812V13.6152C25.281 13.1339 24.8955 12.7441 24.4209 12.7441H4.5791ZM7.65039 3.72559C7.13625 3.72561 6.71899 4.14331 6.71875 4.65918V7H28.2812V4.65918C28.281 4.14331 27.8638 3.72561 27.3496 3.72559H7.65039Z" fill="black"/>
                    </svg>                
                    {{ tabs.tab03Tab }}
            </button>
        </div>

        <!-- BOOKING FORM -->
        <div
            role="tabpanel"
            id="panel-tab01"
            aria-labelledby="tab-tab01"
            v-show="!tabs.tab01Toggle && activeTab === 'tab01'">
            <form class="iso-widget-with-text__form" ref="form" action="" method="get" @submit.prevent="onSubmit" >
                <input type="hidden" name="start" value="" ref="formStartDate" />
                <input type="hidden" name="end" value="" ref="formEndDate" />
                <input type="hidden" name="occupancy" value="" ref="formOccupancy" />
                <input type="hidden" name="salesChannelCode" value="" ref="formSalesChannelCode" />
                <input type="hidden" name="wrk" value="standard" ref="formWorkFlow" />
                <input type="hidden" name="code" value="LLNMAIN" ref="formCode" />
                <input type="hidden" name="hotelCode" value="" ref="formHotelCode" />

                <div class="iso-widget-with-text__form__headlines">
                    <div class="iso-widget-with-text__form__headline" data-number="1">{{ myTexts.headingGuests }}</div>
                    <a href="#" class="iso-widget-with-text__form__reset" @click.prevent="onResetForm">{{ myTexts.resetButton }}</a>
                </div>

                <div class="iso-widget-with-text__form__guests-selector-area-wrapper" :class="{ 'is-open': selectGuests }" @keydown="handleGuestsSelectorKeydown">
                    <button type="button" class="iso-form-guests-button" :class="{ 'is-filled': hasGuestsSelected }" @click="toggleGuestsSelector" >
                        <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M8.38867 8.13541C10.9056 8.13545 12.9461 10.1593 12.9463 12.6559V15.2809C12.9463 15.603 12.683 15.8647 12.3584 15.8649H11.5674L10.958 21.902C10.9278 22.2001 10.6751 22.4274 10.373 22.4274H6.4043C6.10224 22.4274 5.84851 22.2001 5.81836 21.902L5.20996 15.8649H4.41895C4.09425 15.8648 3.83105 15.603 3.83105 15.2809V12.6559C3.83123 10.1593 5.87173 8.13541 8.38867 8.13541ZM15.0791 13.5885C16.2682 13.1904 17.5779 13.3844 18.5977 14.11C19.6174 14.8358 20.2229 16.0044 20.2236 17.2497V17.9059C20.2236 18.228 19.9604 18.4897 19.6357 18.4899H18.8105L18.2305 21.9401C18.183 22.2211 17.9377 22.4274 17.6504 22.4274H15.0039C14.7168 22.4272 14.4712 22.221 14.4238 21.9401L14.0928 19.9655C14.0395 19.6477 14.2559 19.3475 14.5762 19.2946C14.8965 19.2417 15.1995 19.4563 15.2529 19.7741L15.5029 21.2604H17.1523L17.7324 17.8102C17.7798 17.529 18.0251 17.3229 18.3125 17.3229H19.0469V17.2506C19.0464 16.3813 18.6242 15.5651 17.9121 15.0583C17.2 14.5515 16.2854 14.416 15.4551 14.694C15.1475 14.7969 14.8138 14.6329 14.71 14.3278C14.6061 14.0226 14.7714 13.6916 15.0791 13.5885ZM8.38867 9.3024C6.52129 9.3024 5.00701 10.8036 5.00684 12.6559V14.6979H5.74219C6.04431 14.6979 6.29709 14.9251 6.32715 15.2233L6.93652 21.2604H9.84082L10.4502 15.2233C10.4803 14.9251 10.733 14.6979 11.0352 14.6979H11.7695V12.6559C11.7694 10.8036 10.256 9.30245 8.38867 9.3024ZM16.3281 8.13541C17.7486 8.13574 18.9002 9.27804 18.9004 10.6872C18.9004 12.0964 17.7488 13.2396 16.3281 13.2399C14.9072 13.2399 13.7549 12.0966 13.7549 10.6872C13.7551 9.27784 14.9073 8.13541 16.3281 8.13541ZM16.3281 9.3024C15.5569 9.3024 14.9308 9.92217 14.9307 10.6872C14.9307 11.4523 15.5568 12.0729 16.3281 12.0729C17.0992 12.0726 17.7246 11.4521 17.7246 10.6872C17.7244 9.92237 17.0991 9.30273 16.3281 9.3024ZM8.38867 1.57291C10.1748 1.57295 11.6229 3.00918 11.623 4.78091C11.623 6.5528 10.1749 7.98985 8.38867 7.9899C6.60238 7.9899 5.1543 6.55283 5.1543 4.78091C5.15447 3.00915 6.60249 1.57291 8.38867 1.57291ZM8.38867 2.7399C7.25205 2.7399 6.33026 3.65348 6.33008 4.78091C6.33008 5.9085 7.25194 6.82291 8.38867 6.82291C9.52536 6.82286 10.4473 5.90847 10.4473 4.78091C10.4471 3.65351 9.52526 2.73995 8.38867 2.7399Z" fill="black"/>
                        </svg>
                        <span v-text="guestsToggleButtonText"></span>
                        <svg aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                            <path d="M8.05025 9.53553L12.2929 5.29289C12.6834 4.90237 13.3166 4.90237 13.7071 5.29289C14.0976 5.68342 14.0976 6.31658 13.7071 6.70711L8.05025 12.364L2.3934 6.70711C2.00287 6.31658 2.00287 5.68342 2.3934 5.29289C2.78392 4.90237 3.41709 4.90237 3.80761 5.29289L8.05025 9.53553Z" fill="black"/>
                        </svg>
                    </button>

                    <div class="iso-widget-with-text__form__guests-selector-area" v-show="selectGuests">
                        <div class="guests-selector-area__inner">
                            <div class="close-overlay" @click="selectGuests = false">
                                <div class="close-overlay__line"></div>
                                <div class="close-overlay__line"></div>
                            </div>
                            <h3 class="guest-selector-headline">{{ myTexts.guestOverlayHeadlineMobile }}</h3>
                            <div class="number-stepper number-stepper--adults">
                                <label :id="adultsLabelID" class="iso-booking-label">{{ myTexts.adultsPlural}} ({{ myTexts.adultsAgeDescription }})</label>
                                <div class="number-stepper__controls" role="group" :aria-labelledby="adultsLabelID">
                                    <button 
                                        class="number-stepper__decrease"
                                        type="button" 
                                        @click="decrementAdults" 
                                        :disabled="guests.adults <= 0"
                                        aria-label="Decrease adults">
                                    </button>
                                    <span class="number-stepper__value" aria-live="polite">{{ guests.adults }}</span>
                                    <button 
                                        class="number-stepper__increase"
                                        type="button" 
                                        @click="incrementAdults" 
                                        :disabled="guests.adults >= maxAdults"
                                        aria-label="Increase adults">
                                    </button>
                                </div>
                            </div>
                            <div v-show="errors.adults" class="error-message error-message--adult">{{ myTexts.adultsErrorText }}</div>

                            <div class="number-stepper">
                                <label :id="childrenLabelID" class="iso-booking-label">{{ myTexts.childrenPlural}} ({{ myTexts.childrenAgeDescription }})</label>
                                <div class="number-stepper__controls" role="group" :aria-labelledby="childrenLabelID">
                                    <button 
                                        class="number-stepper__decrease"                                
                                        type="button" 
                                        @click="decrementChildren" 
                                        :disabled="guests.children.length <= 0"
                                        aria-label="Decrease children">
                                    </button>
                                    <span class="number-stepper__value" aria-live="polite">{{ guests.children.length }}</span>
                                    <button 
                                        class="number-stepper__increase"
                                        type="button" 
                                        @click="incrementChildren" 
                                        :disabled="guests.children.length >= maxChildren"
                                        aria-label="Increase children">
                                    </button>
                                </div>
                            </div>
                            <div class="child-list-wrapper" v-show="guests.children.length > 0">
                                <ul class="child-list">
                                    <li v-for="(child, index) in guests.children" :key="index">
                                        <label class="iso-booking-label child-label">
                                            <span>{{myTexts.childrenSingle}} {{index+1}} ({{ myTexts.age }})</span>
                                            <select class="small" @change="setChildAge($event, index)">
                                                <option disabled value="" selected>{{ myTexts.dropdownDefault }}</option>
                                                <option value="0">0</option>
                                                <option v-for="(n, optionIndex) in maxChildAge" :key="optionIndex" :value="n">{{ n }}</option>
                                            </select>
                                        </label>
                                    </li>
                                </ul>
                                <div v-show="errors.children" class="error-message">{{ myTexts.childrenErrorText }}</div>
                            </div>
                            
                            <button type="button" class="button button--primary iso-form-button guest-btn-confirm" @click="onConfirmGuests">{{ myTexts.continueButton }}</button>
                        </div>
                    </div>

                </div>
                <div>
                    <HotelDatePicker 
                        ref="datepicker"
                        :i18n="getInternationalization" 
                        :format="getFormat"
                        :firstDayOfWeek="getFirstDayOfWeek" 
                        :show-single-month="true"
                        :position-right="true"
                        :startDate="new Date(this.$props.formStartDate)"
                        :hoveringTooltip="false"
                        @periodSelected="onPeriodSelected"
                        @clear-selection="onClearSelection">
                    </HotelDatePicker>
                    <div v-show="errors.dates" class="error-message error-message--date">{{ myTexts.datesErrorText }}</div>
                </div>

                <button type="submit" class="button button--primary iso-form-button">{{ myTexts.searchButton }}</button>

                <div v-if="ticketsOnlyLinkUrl && ticketsOnlyLinkText" class="iso-widget-with-text__form__separator"><span>{{ myTexts.orSeparatorLabel }}</span></div>
                <div v-if="ticketsOnlyLinkUrl && ticketsOnlyLinkText">
                    <a :href="ticketsOnlyLinkUrl" class="button button--primary iso-form-button">{{ ticketsOnlyLinkText }}</a>
                </div>
            </form>
        </div>

        <!-- TICKETS TEXT -->
        <div
            class="iso-widget-with-text__widget__tabpanel"
            role="tabpanel"
            id="panel-tab02"
            aria-labelledby="tab-tab02"
            v-show="!tabs.tab02Toggle && activeTab === 'tab02'">
            <h2 v-if="tabs.tab02Headline">{{ tabs.tab02Headline }}</h2>
            <div v-html="tabs.tab02Text"></div>
            <div v-html="tabs.tab02Button"></div>
        </div>

        <!-- ANNUAL PASS TEXT -->
        <div
            class="iso-widget-with-text__widget__tabpanel"
            role="tabpanel"
            id="panel-tab03"
            aria-labelledby="tab-tab03"
            v-show="!tabs.tab03Toggle && activeTab === 'tab03'">
            <h2 v-if="tabs.tab03Headline">{{ tabs.tab03Headline }}</h2>
            <div v-html="tabs.tab03Text"></div>
            <div v-html="tabs.tab03Button"></div>
        </div>        
    </div>
</template>

<script>
    import HotelDatePicker from "vue-hotel-datepicker";
    import { v4 as uuidv4 } from 'uuid';
    import { i18n } from "../../../i18n/vue-hotel-datepicker/i18n.js";

    export default {
        props: {
            workflow: {
                type: String,
                required: true
            },
            code: {
                type: String
            },
            hotelCode: {
                type: String
            },
            salesChannelCode: {
                type: String
            },
            tabs: {
                type: Object
            },            
            texts: {
                type: Object
            },
            i18n: {
                type: String
            },
            formAction: {
                type: String
            },
            formStartDate: {
                type: String
            },
            ticketsOnlyLinkUrl: {
                type: String
            },
            ticketsOnlyLinkText: {
                type: String
            }
        },
        components: {
            HotelDatePicker
        },
        data() {
            return {
                isDatepickerOpen: false,
                activeTab: 'tab01',
                focusedTab: 'tab01',
                adultsLabelID: 'id-' + uuidv4().substring(0,8),
                childrenLabelID: 'id-' + uuidv4().substring(0,8),
                maxAdults: 8,
                maxChildren: 8,
                maxChildAge: 17,
                startDate: '',
                endDate: '',
                selectGuests: false,
                guests: {
                    adults: 0,
                    infants: 0,
                    children: []
                },
                tabs: {
                    tab01Tab: '',
                    tab01Toggle: false,
                    tab02Tab: '',
                    tab02Toggle: false,
                    tab02Headline: '',
                    tab02Text: '',
                    tab02Button: '',
                    tab03Tab: '',
                    tab03Toggle: false,
                    tab03Headline: '',
                    tab03Text: '',
                    tab03Button: ''
                },
                myTexts: {
                    adultsSingle: '',
                    adultsPlural: '',
                    adultsAgeDescription: '',
                    childrenSingle: '',
                    childrenPlural: '',
                    childrenAgeDescription: '',
                    headingGuests: '',
                    dropdownDefault: '',
                    age: '',
                    searchButton: '',
                    resetButton: '',
                    guestOverlayHeadlineMobile: '',
                    dateOverlayHeadlineMobile: '',
                    continueButton: '',
                    orSeparatorLabel: '',
                    adultsErrorText: '',
                    childrenErrorText: '',
                    datesErrorText: ''
                },
                i18nFallback: {
                    firstDayOfWeek: 0,
                    data: {
                        "night": "Night",
                        "nights": "Nights",
                        "week": "week",
                        "weeks": "weeks",
                        "day-names": ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"],
                        "check-in": "Check-in",
                        "check-out": "Check-out",
                        "month-names": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
                        "tooltip": {
                            "halfDayCheckIn": "Available CheckIn",
                            "halfDayCheckOut": "Available CheckOut",
                            "saturdayToSaturday": "Only Saturday to Saturday",
                            "sundayToSunday": "Only Sunday to Sunday",
                            "minimumRequiredPeriod": "%{minNightInPeriod} %{night} minimum.",
                        },
                    },
                    format: 'DD/MM/YYYY'
                },
                errors: {
                    dates: false,
                    adults: false,
                    children: false
                },
            }
        },
        mounted() {
            this.$refs.formWorkFlow.value = this.$props.workflow;
            this.$refs.formCode.value = this.$props.code;
            this.$refs.formHotelCode.value = this.$props.hotelCode;
            this.$refs.formSalesChannelCode.value = this.$props.salesChannelCode;
            this.myTexts = this.$props.texts;
            this.tabs = this.$props.tabs;
            this.$refs.form.action = this.$props.formAction;

            const firstVisible = ['tab01', 'tab02', 'tab03']
                .find(t => !this.tabs[`${t}Toggle`]);
            if (firstVisible) this.activeTab = firstVisible;

            // Add tab keyboard navigation
            this.$el.querySelector('[role="tablist"]').addEventListener('keydown', this.handleTabKeydown);
            
            // Initial check for datepicker filled state
            this.checkDatepickerFilledState();
            
            // Watch for changes to datepicker inputs using MutationObserver
            this.setupDatepickerObserver();           

            // Add click outside listener for guests selector
            document.addEventListener('click', this.handleClickOutside);       
            
            // Add Escape key listener for datepicker
            document.addEventListener('keydown', this.handleEscapeKey);            
        },
        beforeUnmount() {
            this.$el.querySelector('[role="tablist"]')?.removeEventListener('keydown', this.handleTabKeydown);

            // Clean up mutation observer
            if (this.datepickerObserver) {
                this.datepickerObserver.disconnect();
            }            

            // Clean up click outside listener
            document.removeEventListener('click', this.handleClickOutside);            

            // Clean up Escape key listener
            document.removeEventListener('keydown', this.handleEscapeKey);            
        },        
        methods: {
            checkDatepickerFilledState() {
                this.$nextTick(() => {
                    const inputs = this.$el.querySelectorAll('.vhd__datepicker__input');
                    inputs.forEach(input => {
                        const text = input.textContent.trim();
                        if (text !== 'Check-in' && text !== 'Check-out') {
                            input.classList.add('is-filled');
                        } else {
                            input.classList.remove('is-filled');
                        }
                    });
                });
            },
            setupDatepickerObserver() {
                this.$nextTick(() => {
                    const datepickerWrapper = this.$el.querySelector('.vhd__datepicker__wrapper');
                    if (!datepickerWrapper) return;

                    // Store the focusout handler so we can remove it later
                    let focusOutHandler = null;

                    this.datepickerObserver = new MutationObserver(() => {
                        this.checkDatepickerFilledState();

                        // Check if calendar is open
                        const calendarVisible = this.$el.querySelector('.vhd__datepicker__inner');
                        if (calendarVisible && !this.isDatepickerOpen) {
                            this.isDatepickerOpen = true;

                            const closeOverlay = document.createElement('div');
                            closeOverlay.className = 'close-overlay';
                            closeOverlay.innerHTML = `<div class="close-overlay__line"></div><div class="close-overlay__line"></div>`;                            

                            const dateSelectorHeadline = document.createElement('h3');
                            dateSelectorHeadline.className = 'date-selector-headline';
                            dateSelectorHeadline.textContent = this.myTexts.dateOverlayHeadlineMobile;

                            // // Add click handler to close the datepicker
                            closeOverlay.addEventListener('click', () => {
                                // Close the datepicker by triggering clearSelection or hiding it
                                if (this.$refs.datepicker && this.$refs.datepicker.hideDatepicker) {
                                    this.$refs.datepicker.hideDatepicker();
                                }
                                this.isDatepickerOpen = false;
                            });        

                            // // Append to the calendar
                            calendarVisible.prepend(closeOverlay, dateSelectorHeadline);
                        } else if (!calendarVisible && this.isDatepickerOpen) {
                            // Reset flag when calendar closes
                            this.isDatepickerOpen = false;
                        }  
                    });

                    this.datepickerObserver.observe(datepickerWrapper, {
                        childList: true,
                        subtree: true,
                        characterData: true
                    });
                });
            },            
            setActiveTab(tabName) {
                this.activeTab = tabName;
                this.focusedTab = tabName;
                
                // Focus the active tab button
                this.$nextTick(() => {
                    const activeButton = this.$el.querySelector(`#tab-${tabName}`);
                    if (activeButton) {
                        activeButton.focus();
                    }
                });
                
                // Close any open dropdowns when switching tabs
                this.hidePopUps();
            },            
            handleClickOutside(event) {
                const wrapper = this.$el.querySelector('.iso-widget-with-text__form__guests-selector-area-wrapper');
                if (wrapper && !wrapper.contains(event.target) && this.selectGuests) {
                    this.selectGuests = false;
                }
            },     
            handleEscapeKey(event) {
                if (event.key === 'Escape' && this.isDatepickerOpen) {
                    event.preventDefault();
                    if (this.$refs.datepicker && this.$refs.datepicker.hideDatepicker) {
                        this.$refs.datepicker.hideDatepicker();
                    }
                    this.isDatepickerOpen = false;
                }
            },            
            handleGuestsSelectorKeydown(event) {
                // Close on Escape
                if (event.key === 'Escape' && this.selectGuests) {
                    event.preventDefault();
                    this.selectGuests = false;
                    // Return focus to the toggle button
                    this.$nextTick(() => {
                        const toggleButton = this.$el.querySelector('.iso-form-guests-button');
                        if (toggleButton) {
                            toggleButton.focus();
                        }
                    });
                    return;
                }

                // Focus trap for Tab key
                if (event.key === 'Tab' && this.selectGuests) {
                    const wrapper = this.$el.querySelector('.iso-widget-with-text__form__guests-selector-area-wrapper');
                    if (!wrapper) return;

                    const focusableElements = wrapper.querySelectorAll(
                        'button:not([disabled]), select:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])'
                    );
                    
                    if (focusableElements.length === 0) return;

                    const firstElement = focusableElements[0];
                    const lastElement = focusableElements[focusableElements.length - 1];

                    // Shift+Tab on first element - wrap to last
                    if (event.shiftKey && document.activeElement === firstElement) {
                        event.preventDefault();
                        lastElement.focus();
                    }
                    // Tab on last element - wrap to first
                    else if (!event.shiftKey && document.activeElement === lastElement) {
                        event.preventDefault();
                        firstElement.focus();
                    }
                }
            },             
            hidePopUps() {
                this.selectGuests = false;
            },
            handleTabKeydown(event) {
                const tabs = ['tab01', 'tab02', 'tab03'];
                const currentIndex = tabs.indexOf(this.focusedTab);
                
                // Arrow keys move focus only
                if (event.key === 'ArrowRight') {
                    event.preventDefault();
                    const nextIndex = (currentIndex + 1) % tabs.length;
                    this.focusedTab = tabs[nextIndex];
                    const nextButton = this.$el.querySelector(`#tab-${tabs[nextIndex]}`);
                    if (nextButton) {
                        nextButton.focus();
                    }
                } else if (event.key === 'ArrowLeft') {
                    event.preventDefault();
                    const prevIndex = (currentIndex - 1 + tabs.length) % tabs.length;
                    this.focusedTab = tabs[prevIndex];
                    const prevButton = this.$el.querySelector(`#tab-${tabs[prevIndex]}`);
                    if (prevButton) {
                        prevButton.focus();
                    }
                } else if (event.key === 'Home') {
                    event.preventDefault();
                    this.focusedTab = tabs[0];
                    const firstButton = this.$el.querySelector(`#tab-${tabs[0]}`);
                    if (firstButton) {
                        firstButton.focus();
                    }
                } else if (event.key === 'End') {
                    event.preventDefault();
                    this.focusedTab = tabs[tabs.length - 1];
                    const lastButton = this.$el.querySelector(`#tab-${tabs[tabs.length - 1]}`);
                    if (lastButton) {
                        lastButton.focus();
                    }
                }
            },   
            getTabIndex(tabName) {
                // Only the focused tab should be tabbable
                return this.focusedTab === tabName ? 0 : -1;
            },                  
            onResetForm() {
                this.guests.adults = 0;
                this.guests.children = [];
                this.$refs.datepicker.clearSelection();
                this.selectGuests = false;
                this.errors.adults = false;
                this.errors.dates = false;
                this.errors.children = false;
            },
            toggleGuestsSelector() {
                this.selectGuests = !this.selectGuests;
            },
            onConfirmGuests() {
                // Validate guests
                const hasAdultsError = this.guests.adults <= 0;
                const hasChildrenError = this.guests.children.length > 0 && this.guests.children.some(x => x.age === null);
                
                // Set error states
                this.errors.adults = hasAdultsError;
                this.errors.children = hasChildrenError;
                
                // Only close if there are no errors
                if (!hasAdultsError && !hasChildrenError) {
                    this.selectGuests = false;

                    // Open datepicker after closing guest overlay
                    this.$nextTick(() => {
                        if (this.$refs.datepicker && this.$refs.datepicker.showDatepicker) {
                            this.$refs.datepicker.showDatepicker();
                        }
                    });                    
                }
            },            
            onClearSelection() {
                this.startDate = '';
                this.endDate = '';
            },
            onPeriodSelected(event, date1, date2) {
                this.startDate = date1;
                this.endDate = date2;
                this.errors.dates = false;
            },
            setAdults() {
                this.errors.adults = false;
            },
            incrementAdults() {
                if (this.guests.adults < this.maxAdults) {
                    this.guests.adults++;
                    this.errors.adults = false;
                }
            },
            decrementAdults() {
                if (this.guests.adults > 0) {
                    this.guests.adults--;
                }
            },
            incrementChildren() {
                if (this.guests.children.length < this.maxChildren) {
                    this.guests.children.push({ age: null });
                }
            },
            decrementChildren() {
                if (this.guests.children.length > 0) {
                    this.guests.children.pop();
                    this.errors.children = this.guests.children.some(x => x.age === null);
                }
            },
            setChildAge(event, index) {
                const val = event.target.value
                this.guests.children[index].age = val;
                this.errors.children =  this.guests.children.some(x => x.age === null);
            },
            updateHiddenFormElements() {
                //Handle dates
                const dStart = `${new Intl.DateTimeFormat('en-US', { year: 'numeric'}).format(this.startDate)}-${new Intl.DateTimeFormat('en-US', { month: '2-digit'}).format(this.startDate)}-${new Intl.DateTimeFormat('en-US', { day: '2-digit'}).format(this.startDate)}`;
                const dEnd   = `${new Intl.DateTimeFormat('en-US', { year: 'numeric'}).format(this.endDate)}-${new Intl.DateTimeFormat('en-US', { month: '2-digit'}).format(this.endDate)}-${new Intl.DateTimeFormat('en-US', { day: '2-digit'}).format(this.endDate)}`;

                this.$refs.formStartDate.value = dStart;
                this.$refs.formEndDate.value = dEnd;

                //Handle guests
                const arr = [];
                const obj = {...this.guests};
                obj.children = this.guests.children.length;
                obj.childrenAges = [];

                this.guests.children.forEach((child) => {
                    obj.childrenAges.push(parseInt(child.age));
                });

                arr.push(obj)
                this.$refs.formOccupancy.value = JSON.stringify(arr);
            },
            onSubmit() {
                if (this.formIsValid) {
                    this.updateHiddenFormElements();
                    this.$refs.form.submit();
                    return;
                }
            }
        },
        computed: {
            hasGuestsSelected() {
                return this.guests.adults > 0 || this.guests.children.length > 0;
            },
            getInternationalization() {
                const culture = document.querySelector('body').dataset.culture;
                console.log('culture: ', culture);
                const arr = i18n.filter(x => x.name.toLowerCase() === this.$props.i18n.toLowerCase());
                
                if (!arr || arr.length === 0) {
                    return this.i18nFallback.data;
                }

                return arr[0].data;
            },
            getFirstDayOfWeek() {
                const arr = i18n.filter(x => x.name.toLowerCase() === this.$props.i18n.toLowerCase());

                if (!arr || arr.length === 0) {
                    return this.i18nFallback.firstDayOfWeek;
                }

                return arr[0].firstDayOfWeek;
            },
            getFormat() {
                const arr = i18n.filter(x => x.name.toLowerCase() === this.$props.i18n.toLowerCase());

                if (!arr || arr.length === 0) {
                    return this.i18nFallback.format;
                }

                return arr[0].format;
            },
            guestsToggleButtonText() {
                if (this.guests.adults === 0 && this.guests.children.length === 0) {
                    return this.myTexts.dropdownDefault;
                }

                const adultString = this.guests.adults === 1 ? this.myTexts.adultsSingle : this.myTexts.adultsPlural;
                const childString = this.guests.children.length === 1 ? this.myTexts.childrenSingle : this.myTexts.childrenPlural;

                return `${this.guests.adults} ${adultString}${this.guests.children.length > 0 ? (', ' + this.guests.children.length + ' ' + childString) : ''}`;
            },
            formIsValid() {
                this.errors.dates = (this.startDate === null || this.startDate === '' || this.startDate === undefined || this.endDate === null || this.endDate === '' || this.endDate === undefined);
                this.errors.adults = this.guests.adults <= 0;
                this.errors.children = (this.guests.children.length > 0 && this.guests.children.some(x => x.age === null));

                if (this.errors.adults || this.errors.children) {
                    this.selectGuests = true;
                }

                if (this.errors.dates || this.errors.adults || this.errors.children) {
                    return false;
                } 
                
                return true;
            }
        },
        watch: {
            selectGuests(newValue) {
                if (newValue) {
                    document.body.classList.add('overflow-hidden-mobile');
                } else {
                    document.body.classList.remove('overflow-hidden-mobile');
                }
            }
        }        
    };
</script>
